import {actions} from './actions';

/**
 *  Indentifico Reducer utilizzati dalla sezione Authorization
 */
const AuthorizationReducers = {
  [actions.AUTHORIZATION_SUCCESS]: (state,action) => { sessionStorage.setItem('auth', JSON.stringify({ token: action.token})); return { ...state, token: action.token, username: action.username, loggedIn: action.loggedIn, roles: action.roles   }},
  [actions.AUTHORIZATION_ERROR]: (state, action) => { sessionStorage.removeItem('auth'); return { ...state, token: action.token, username: action.username, loggedIn: action.loggedIn  }},
}

// da importare nel reducer principale per includerli nello store
export default AuthorizationReducers;